export default __webpack_public_path__ + "static/media/water.89bd269e.svg";